export default __webpack_public_path__ + "static/columnGroups-b738d5b0ca02d3c8a94bae3657fcfd9b.gif";